<template>
  <a-modal
    :title="isViewOnly ? '处置详情' : '申述处置'"
    :visible="visible"
    :confirm-loading="submitLoading"
    width="560px"
    @ok="isViewOnly ? close() : submit()"
    @cancel="close"
  >
    <a-form-model ref="form" :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-form-model-item label="处置结果" prop="result">
        <a-input
          v-model="form.result"
          type="textarea"
          placeholder="请输入处置结果"
          :rows="3"
          :disabled="isViewOnly"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item label="选择师傅" prop="selectedMasterIds">
        <a-checkbox-group v-model="form.selectedMasterIds" :disabled="isViewOnly">
          <template v-if="masterList.length">
            <div v-for="m in masterList" :key="m.userId" style="margin-bottom: 8px;">
              <a-checkbox :value="m.userId" :disabled="isViewOnly">{{ m.userName }}</a-checkbox>
            </div>
          </template>
          <span v-else class="oa-placeholder">该订单下暂无师傅或加载中...</span>
        </a-checkbox-group>
        <div v-if="(form.isDeduct || form.isRestrictOrder) && masterList.length && !isViewOnly" class="oa-hint">扣分、限制接单仅对勾选的师傅生效</div>
      </a-form-model-item>
      <a-form-model-item label="是否扣分" prop="isDeduct">
        <a-space align="center">
          <a-switch v-model="form.isDeduct" :disabled="isViewOnly" />
          <template v-if="form.isDeduct">
            <span>扣</span>
            <a-input-number
              v-model="form.deductionScore"
              :min="0"
              :max="100"
              placeholder="0"
              :disabled="isViewOnly"
              style="width: 80px"
            />
            <span>分</span>
          </template>
        </a-space>
      </a-form-model-item>
      <a-form-model-item label="是否限制接单" prop="isRestrictOrder">
        <a-space align="center">
          <a-switch v-model="form.isRestrictOrder" :disabled="isViewOnly" />
          <template v-if="form.isRestrictOrder">
            <span>限制接单</span>
            <a-input-number
              v-model="form.day"
              :min="0"
              :max="365"
              placeholder="0"
              :disabled="isViewOnly"
              style="width: 80px"
            />
            <span>天</span>
          </template>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { getOrderAppeal, handleOrderAppeal } from '@/api/orderAppeal/orderAppeal'
import { listOrder as listMasterOrder } from '@/api/master/order'

export default {
  name: 'HandleModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: null
    }
  },
  computed: {
    isViewOnly() {
      return this.record && Number(this.record.status) === 2
    }
  },
  data() {
    return {
      submitLoading: false,
      detailRecord: null,
      masterList: [],
      form: {
        handleType: undefined,
        result: '',
        selectedMasterIds: [],
        isDeduct: false,
        deductionScore: 0,
        isRestrictOrder: false,
        day: 0
      },
      handleTypeOptions: [
        
      ]
    }
  },
  watch: {
    visible(val) {
      if (val && this.record && this.record.id) {
        this.resetForm()
        this.loadDetail()
        this.loadMasterList()
      }
    }
  },
  methods: {
    loadDetail() {
      if (!this.record || !this.record.id) return
      getOrderAppeal({ id: this.record.id }).then(res => {
        const raw = res.data || res
        const data = raw.data || raw
        this.detailRecord = { ...data }
        this.form.handleType = data.handleType !== undefined && data.handleType !== null ? data.handleType : undefined
        this.form.result = data.result || ''
        this.form.isDeduct = !!(data.deductionScore != null && Number(data.deductionScore) > 0)
        this.form.deductionScore = data.deductionScore != null ? Number(data.deductionScore) : 0
        this.form.isRestrictOrder = !!(data.day != null && Number(data.day) > 0)
        this.form.day = data.day != null ? Number(data.day) : 0
        if (data.masterUserIds && typeof data.masterUserIds === 'string') {
          this.form.selectedMasterIds = data.masterUserIds.split(',')
          console.log(this.form.selectedMasterIds)
        } else {
          this.form.selectedMasterIds = []
        }
      })
    },
    loadMasterList() {
      const orderId = this.record && this.record.orderId
      if (!orderId) {
        this.masterList = []
        return
      }
      listMasterOrder({ customerOrderId: orderId }).then(res => {
        const raw = res.data || res
        const list = Array.isArray(raw) ? raw : (raw.data && Array.isArray(raw.data) ? raw.data : [])
        this.masterList = list.map(item => ({
          userId: item.userId,
          userName: item.userName
        }))
      }).catch(() => {
        this.masterList = []
      })
    },
    resetForm() {
      this.form = {
        handleType: undefined,
        result: '',
        selectedMasterIds: [],
        isDeduct: false,
        deductionScore: 0,
        isRestrictOrder: false,
        day: 0
      }
      this.detailRecord = null
      this.masterList = []
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('cancel')
    },
    submit() {
      if (!this.detailRecord || !this.detailRecord.id) {
        this.$message.warning('请先加载申述详情')
        return
      }
      if ((this.form.isDeduct || this.form.isRestrictOrder) && (!this.form.selectedMasterIds || !this.form.selectedMasterIds.length)) {
        this.$message.warning('扣分或限制接单时请至少选择一名师傅')
        return
      }
      const masterUserIds = Array.isArray(this.form.selectedMasterIds) && this.form.selectedMasterIds.length
        ? this.form.selectedMasterIds.join(',')
        : ''
      const payload = {
        id: this.detailRecord.id,
        result: this.form.result || '',
        handleType: this.form.handleType,
        deductionScore: this.form.isDeduct ? (this.form.deductionScore || 0) : 0,
        day: this.form.isRestrictOrder ? (this.form.day || 0) : 0,
        masterUserIds
      }
      this.submitLoading = true
      handleOrderAppeal(payload)
        .then(() => {
          this.$message.success('处置成功')
          this.close()
          this.$emit('ok')
        })
        .finally(() => {
          this.submitLoading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.oa-placeholder { color: #999; font-size: 12px; }
.oa-hint { color: #999; font-size: 12px; margin-top: 4px; }
</style>
